import React from "react";
import TableCard from "../../shared/TableCard/TableCard";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FilterMatchMode, FilterOperator } from "primereact/api";

export default function ItemsTable({ heading, items, loading, search, setSearch, onEdit, onDelete, formType, showActions = true }) {
    const actions = (d) => {
        return (
            <div className="flex justify-content-around gap-1">
                {formType === "VIEW" && <i className="pi pi-eye cursor-pointer" onClick={(e) => onEdit(d)}></i>}
                {formType === "EDIT" && <i className="pi pi-pencil cursor-pointer" onClick={(e) => onEdit(d)}></i>}
                {formType === "EDIT" && <i className="pi pi-trash cursor-pointer" onClick={(e) => onDelete(e, d._id)}></i>}
            </div>
        );
    };

    const filters = {
        time: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        subscriptionExpireOn: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    };

    return (
        <>
            <TableCard title={heading} onSearch={setSearch} searchKeyword={search}>
                <DataTable
                    paginator
                    value={items}
                    selectionMode="checkbox"
                    showGridlines
                    filter={filters}
                    filterDisplay="menu"
                    rows={10}
                    loading={loading}
                    emptyMessage={`No ${heading} found.`}
                >
                    <Column header="Name" field="name"></Column>
                    <Column header="Price($)" field="price"></Column>
                    {showActions ? <Column body={actions} style={{ width: "100px" }} header="Action"></Column> : null}
                </DataTable>
            </TableCard>
        </>
    );
}
